export default __webpack_public_path__ + "static/media/icon_Two.324d5005.png";